import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f834fe94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chc-table" }
const _hoisted_2 = { class: "chc-table-thead" }
const _hoisted_3 = { class: "chc-table-row" }
const _hoisted_4 = { class: "chc-table-tbody" }
const _hoisted_5 = ["title"]

import { computed, type StyleValue } from 'vue';
type ColumnType = {
  title: string,
  dataIndex: string,
  width?: string | number,
  fixed?: string
}
type ScrollObjProp = {
  x: string | number
  y: string | number
}
interface CTableProps {
  columns: ColumnType[],
  data: any[],
  rowId?: string,
  scroll?: ScrollObjProp,
  bordered?: boolean
}

const __default__ = {
  name: 'CTable'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    columns: null,
    data: null,
    rowId: null,
    scroll: null,
    bordered: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { columns: ColumnType[], data: any[], rowId?: string, scroll?: ScrollObjProp, bordered: boolean };


const computedTHeadClass = computed(() => {
  return (column, ind) => {
    if (column.fixed == 'left') {
      if (!props.columns[ind + 1]?.fixed) {
        return {
          'chc-table-cell-th-fix-left': true,
          'chc-table-cell-th-fix-left-last': true
        }
      } else {
        return {
          'chc-table-cell-th-fix-left': true
        }
      }
    } else if (column.fixed == 'right') {
      if (!props.columns[ind - 1]?.fixed) {
        return {
          'chc-table-cell-th-fix-right': true,
          'chc-table-cell-th-fix-right-first': true
        }
      } else {
        return {
          'chc-table-cell-th-fix-right': true
        }
      }
    }
  }
})
const computedTBodyClass = computed(() => {
  return (column, ind) => {
    if (column.fixed == 'left') {
      if (!props.columns[ind + 1]?.fixed) {
        return {
          'chc-table-cell-fix-left': true,
          'chc-table-cell-fix-left-last': true,
        }
      } else {
        return {
          'chc-table-cell-fix-left': true
        }
      }
    } else if (column.fixed == 'right') {
      if (!props.columns[ind - 1]?.fixed) {
        return {
          'chc-table-cell-fix-right': true,
          'chc-table-cell-fix-right-first': true
        }
      } else {
        return {
          'chc-table-cell-fix-right': true
        }
      }
    }
  }
})
const computedStyle = computed(() => {
  return (column: ColumnType, ind: number): StyleValue | undefined => {
    if (column.width && !column.fixed) {
      return {
        width: column.width + 'px',
        border: props.bordered ? '1px solid #f0f0f0' : ''
      }
    } else if (column.fixed == 'left' && column.width) {
      let width = 0
      if (ind == 0) {
        width = 0
      } else {
        for (let i = 0; i < ind; i++) {
          width += parseInt(props.columns[i]?.width!.toString())
        }
      }
      return {
        position: 'sticky',
        left: width + 'px',
        width: column.width + 'px',
        maxWidth:column.width + 'px',
        border: props.bordered ? '1px solid #f0f0f0' : ''
      }

    } else if (column.fixed == 'right' && column.width) {
      let width = 0;
      if (ind == props.columns.length - 1) {
        width = 0
      } else {
        for (let i = props.columns.length - 1; i > ind; i--) {
          width += parseInt(props.columns[i]?.width!.toString())
        }
      }
      return {
        position: 'sticky',
        right: width + 'px',
        width: column.width + 'px',
        maxWidth:column.width + 'px',
        border: props.bordered ? '1px solid #f0f0f0' : ''
      }
    } else {
      return {
        border: props.bordered ? '1px solid #f0f0f0' : ''
      }
    }

  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "chc-table-container",
      style: _normalizeStyle({ overflow: 'auto auto', maxHeight: __props.scroll?.y + 'px' })
    }, [
      _createElementVNode("table", {
        style: _normalizeStyle([{"table-layout":"auto","width":"100%","border-collapse":"collapse"}, { width: __props.scroll?.x + 'px', minWidth: '100%', tableLayout: 'fixed' }])
      }, [
        _createElementVNode("thead", _hoisted_2, [
          _createElementVNode("tr", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, ind) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass(["chc-table-cell chc-table-cell-fix-top", _unref(computedTHeadClass)(column, ind)]),
                key: column.dataIndex,
                style: _normalizeStyle(_unref(computedStyle)(column, ind))
              }, _toDisplayString(column.title), 7))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "chc-table-row",
              key: __props.rowId ? item[__props.rowId] : index
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, ind) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: _normalizeClass(["chc-table-cell", _unref(computedTBodyClass)(column, ind)]),
                  key: column.dataIndex,
                  style: _normalizeStyle(_unref(computedStyle)(column, ind))
                }, [
                  (column.dataIndex == 'dataIndex')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(index + 1), 1)
                      ], 64))
                    : _renderSlot(_ctx.$slots, "bodyCell", {
                        key: 1,
                        column: column,
                        record: item
                      }, () => [
                        _createElementVNode("span", {
                          title: item[column.dataIndex]
                        }, _toDisplayString(item[column.dataIndex]), 9, _hoisted_5)
                      ])
                ], 6))
              }), 128))
            ]))
          }), 128))
        ])
      ], 4)
    ], 4)
  ]))
}
}

})